import store from "../store/store";
import { addMessage, setActiveChat, setChats, updateChatId } from "../slices/chatSlice";
import { logout, setTaskUser } from "../slices/userSlise";

// type: event
const handlers = {
    message: {
        chatMessage: (controller, message) => {
            if (message.payload?.tempId) {
                store.dispatch(updateChatId(message.payload));
                store.dispatch(setActiveChat(message.payload.chatId));
            }
            store.dispatch(addMessage(message.payload));
        },
        chatCreated: (controller, message) => {
            store.dispatch(updateChatId(message.payload));
            store.dispatch(setActiveChat(message.payload.chatId));
        },
    },
    system: {
        chats: (controller, message) => {
            console.log((typeof(message.payload.chats)))
            if (Array.isArray(message.payload.chats)){
                store.dispatch(setChats(message.payload.chats));
            }
        },
        navigate: (controller, message) => {
            const { path, taskAssessment } = message.payload;
            if (path === '/risktable') {
                // store.dispatch(setTaskUser(taskAssessment));
                // localStorage.setItem('taskAssessment', JSON.stringify(taskAssessment));
                const { name, date, time, location } = store.getState().user;
                const taskData = {
                    taskAssessment: taskAssessment,
                    name: name,
                    date: date,
                    time: time,
                    location: location.locationName,
                };
                localStorage.setItem('taskAssessment', JSON.stringify(taskData));
                setTimeout(() => {
                    window.location.href = path;
                }, 0);
            } else {
                window.location.href = path;
            }
        },
    },
    event: {},
    notification: {},
    error: {
        authentication: (controller, message) => {
            controller.disconnect();
            store.dispatch(logout());
        }
    },
}

const messageRouter = async (controller, message) => {

    if (!message.type || !message.event) {
        console.warn('Invalid message format: ', message);
        return;
    }
    
    const typeHandlers = handlers[message.type];
    if (typeHandlers) {
        const handler = typeHandlers[message.event];
        if (handler) {
            handler(controller, message);
        }
    } else {
        console.warn('Unknown type message: ', message);
    }


    // if (message.type === "chatMessage") {
    //     store.dispatch(addMessage({sender: 'bot', text: message.payload, timestamp: new Date().toISOString()}));
    // } else if (message.type === 'authenticate' && message.status === 'denied') {
    //     console.warn('Authenticate error: ', message.message);
    //     controller.disconnect();
    //     store.dispatch(logout());
    // } else if (message.type === "error") {
    //     console.log("Intercept error message from server", message.error);
    // } else {
    //     console.warn("Unknown message type: ", message);
    // }
};

export default messageRouter;
